<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <transition
          appear
          name="component-fade"
          mode="out-in"
        >
          <div v-if="currentStep == 1" class="card" key="1">
            <div class="card-title primary white-text">
              Select a plan
            </div>

            <div class="card-content">
              <div v-if="loadingList" class="progress">
                <div class="indeterminate"></div>
              </div>
              <div class="row">
                <div v-for="item in planList" :key="item.id" class="col s12 m6 l3 center-align">
                  <div :class="['selection-box', (item.id === planID) ? 'active' : '']">
                    <div v-if="item.duration === '12'" class="center-badge green">BEST VALUE</div>
                    <a @click="choosePlan(item.id)" class="waves-effect">
                      <div class="text mt-2 mb-2">
                        <b>{{ item.duration }} months</b><br>
                        at INR {{ formatAmount(item.rate) }} per month
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentStep == 2" class="card" key="2">
            <div class="card-title primary white-text">
              <a @click="goToPlanSelection" class="btn btn-floating btn-flat">
                <i class="material-icons">keyboard_arrow_left</i>
              </a>
              Bookshelf Registration Form<br>
            </div>

            <div class="card-content">
              <div v-if="loadingList" class="progress">
                <div class="indeterminate"></div>
              </div>

              <div class="row">
                <div class="input-field col s12">
                  Please fill out this form to register for a Bookshelf subscription for your child
                </div>
              </div>

              <div class="row">
                <div class="input-field col s12 m6">
                  <input
                    type="email"
                    id="email"
                    v-model="editedItem.email"
                    :readonly="isAuthenticated"
                    @change="checkEmail"
                  >
                  <label for="email">Email address</label>
                  <span class="helper-text red-text">{{ (formErrors.email !== '') ? formErrors.email : '' }}</span>
                </div>

                <div v-show="emailExists" class="input-field col s12 mt-0 mb-0">
                  <div class="card-panel brown lighten-5 z-depth-0 mt-0">
                    <div class="mb-1">
                      It looks like you already have an account with us.
                    </div>
                    <a @click="goToLogin" class="btn primary waves-effect waves-light">
                      <i class="material-icons right">chevron_right</i>
                      Login
                    </a>
                  </div>
                </div>
              </div>

              <div class="row" v-show="!emailExists">
                <div class="input-field col s12 m6">
                  <input
                    type="text"
                    id="name"
                    v-model="editedItem.name"
                    :readonly="isAuthenticated"
                  >
                  <label for="name">Your Name</label>
                  <span class="helper-text">Parent's / Adult's Name</span>
                  <span class="helper-text red-text">{{ (formErrors.name !== '') ? formErrors.name : '' }}</span>
                </div>

                <div class="input-field col s12 m6">
                  <input
                    type="text"
                    id="phone"
                    v-model="editedItem.phone"
                    :readonly="isAuthenticated"
                  >
                  <label for="phone">Phone number</label>
                  <span class="helper-text red-text">{{ (formErrors.phone !== '') ? formErrors.phone : '' }}</span>
                </div>
              </div>

              <div class="row" v-show="!emailExists">
                <div class="input-field col s12 m6">
                  <select id="city" v-model="deliveryCity">
                    <option value="1" selected>Indore</option>
                    <option value="2">Other</option>
                  </select>
                  <label for="city">Select delivery city</label>
                  <span class="helper-text red-text">{{ (formErrors.deliveryCity !== '') ? formErrors.deliveryCity : '' }}</span>
                </div>

                <div v-show="deliveryCity === '2'" class="input-field col s12 m6">
                  <input
                    type="text"
                    id="city"
                    v-model="editedItem.city"
                  >
                  <label for="city">Delivery City</label>
                  <span class="helper-text red-text">{{ (formErrors.city !== '') ? formErrors.city : '' }}</span>
                </div>

                <div class="col s12 center-align mt-4">
                  <a @click="validateForm" class="btn primary waves-effect waves-light">
                    Next step
                    <i class="material-icons right">keyboard_arrow_right</i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// Import the API functions
import httpApi from '@/utils/api'

import numeral from 'numeral'

export default {
  data () {
    return {
      // Loading status for list of items
      loadingList: true,

      // Can be either 1 (plan) or 2 (basic details and city)
      currentStep: 1,

      planID: 0,

      planList: [],

      emailExists: false,

      deliveryCity: '1',

      editedItem: {
        email: '',
        name: '',
        phone: '',
        city: 'Indore'
      },

      formErrors: {
        email: '',
        name: '',
        phone: '',
        city: '',
        deliveryCity: ''
      }
    }
  },

  watch: {
    deliveryCity (key) {
      if (key === '1') {
        this.editedItem.city = 'Indore'
      } else {
        this.editedItem.city = ''
      }
    }
  },

  computed: {
    // Get vuex store data, to be used in this component
    ...mapGetters(['isAuthenticated'])
  },

  mounted () {
    // On load, get data from API and populate page
    // Make the API call
    httpApi.callWithKey({
      url: 'plan',
      method: 'get'
    })
      .then((resp) => {
        // Deactivate the loading animation
        this.loadingList = false

        // Set the form values to the values of the selected item
        this.planList = Object.assign({}, resp.data.items)
      })
      // If an error occurs
      .catch((err) => {
        // Deactivate the loading animation
        this.loadingList = false

        // Show error
        this.$store.dispatch('SHOW_STATUS_MESSAGE', {
          color: 'error',
          message: err.message
        })
      })
  },

  methods: {
    formatAmount (val) {
      return numeral(val).format('0,0')
    },

    // User selects plan
    choosePlan (planID) {
      this.planID = planID

      // If user is logged in, we do not need their details
      if (this.isAuthenticated) {
        // Fetch user details
        httpApi.callWithToken({
          url: 'user',
          method: 'get'
        })
          .then((resp) => {
            // Assign user details
            this.editedItem.email = resp.data.email
            this.editedItem.name = resp.data.name
            this.editedItem.phone = resp.data.phone

            // Go to next step
            this.currentStep = 2

            setTimeout(() => {
              var elems1 = document.querySelectorAll('select')
              // eslint-disable-next-line
              var instances1 = M.FormSelect.init(elems1, {
                dropdownOptions: {
                  coverTrigger: false
                }
              })

              // eslint-disable-next-line
              M.updateTextFields()
            }, 1000)
          })
          // If an error occurs
          .catch((err) => {
            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: err.message
            })
          })

      // Else ask for user's details
      } else {
        // Go to next step
        this.currentStep = 2

        setTimeout(() => {
          var elems1 = document.querySelectorAll('select')
          // eslint-disable-next-line
          var instances1 = M.FormSelect.init(elems1, {
            dropdownOptions: {
              coverTrigger: false
            }
          })

          // eslint-disable-next-line
          M.updateTextFields()
        }, 1000)
      }
    },

    // Go back to plan selection step
    goToPlanSelection () {
      this.currentStep = 1
    },

    checkEmail () {
      // If email is not empty
      if (this.editedItem.email !== '') {
        // Fetch user details
        httpApi.callWithKey({
          url: 'user/check-email?email=' + this.editedItem.email,
          method: 'get'
        })
          .then((resp) => {
            // Assign details
            if (resp.data.exists === 'y') {
              this.emailExists = true
            } else {
              this.emailExists = false
            }
          })
          // If an error occurs
          .catch(() => {
            // Show error message
          })
      }
    },

    goToLogin () {
      this.$store.commit('SAVE_USER_SUBSCRIPTION_SELECTION', {
        planID: this.planID,
        email: '',
        name: '',
        phone: '',
        toEmail: '',
        toName: '',
        toPhone: '',
        deliveryCity: '',
        city: ''
      })

      // Go to login page
      this.$router.push('/')
    },

    validateForm () {
      // Validate user input data
      let regEmail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/
      let valid = true

      if (this.editedItem.email === '') {
        this.formErrors.email = 'Please enter a valid email address'
        valid = false
      } else if (regEmail.test(this.editedItem.email) === false) {
        this.formErrors.email = 'Please enter a valid email address'
        valid = false
      } else {
        this.formErrors.email = ''
      }
      if (this.editedItem.name === '') {
        this.formErrors.name = 'Please enter the parent\'s / adult\'s name'
        valid = false
      } else {
        this.formErrors.name = ''
      }
      if (this.editedItem.phone === '') {
        this.formErrors.phone = 'Please enter a phone number'
        valid = false
      } else {
        this.formErrors.phone = ''
      }
      if (this.deliveryCity === '2' && this.editedItem.city === '') {
        this.formErrors.city = 'Please enter the delivery city'
        valid = false
      } else {
        this.formErrors.city = ''
      }

      if (valid) {
        // Save user details to store
        this.$store.commit('SAVE_USER_SUBSCRIPTION_SELECTION', {
          planID: this.planID,
          email: this.editedItem.email,
          name: this.editedItem.name,
          phone: this.editedItem.phone,
          toEmail: '',
          toName: '',
          toPhone: '',
          deliveryCity: this.deliveryCity,
          city: this.editedItem.city
        })

        // Go to summary page
        this.$router.push('/summary')
      }
    }
  }
}
</script>
